import { createContext, useReducer, useEffect, useContext, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase/config";
import instance from "instances/axios";
// import { child, get, ref } from 'firebase/database';

export const AuthContext = createContext();
export const authReducer = (state, action) => {
    switch (action.type) {
        // When the action type is "LOGIN", update the state with the new user information
        case "LOGIN":
            return { ...state, user: action.payload };

        // When the action type is "LOGOUT", update the state to remove the user information
        case "LOGOUT":
            return { ...state, user: null };

        // When the action type is "AUTH_IS_READY", update the state with user information and
        // set a state to indicate that the authentication process is complete
        case "AUTH_IS_READY":
            return { user: action.payload, authIsReady: true };

        case "SET_IS_LOADING":
            return { isLoading: true };

        // For any other action type, return the current state without any changes
        default:
            return state;
    }
};

// Authentication context provider component
export const AuthContextProvider = ({ children }) => {
    // Initialize authentication state using a reducer
    const [state, dispatch] = useReducer(authReducer, {
        user: null,
        authIsReady: false,
        isLoading: false,
    });
    const [users, setUsers] = useState([]);

    // Effect to determine initial authentication state and update context
    useEffect(() => {
        // Subscribe to authentication state changes
        const unsub = onAuthStateChanged(auth, async (user) => {
            if (user !== null) {
                const userData = await instance
                    .get("/users/getByEmail/" + user?.email)
                    .then((res) => res.data.data)
                    .catch((error) => {
                        console.error(error);
                    });

                const groups = await instance.get("/groups").then((res) => {
                    return res.data.data
                });
                if (userData) {
                    dispatch({
                        type: "AUTH_IS_READY",
                        payload: { ...userData, photourl: user.photoURL, group: groups.find(a => a.group_id === userData?.group_id) },
                    });
                } else {
                    dispatch({ type: "AUTH_IS_READY", payload: user });
                    console.log("Data not available");
                }
            } else {
                dispatch({ type: "AUTH_IS_READY", payload: null });
            }
            // Unsubscribe to avoid further unnecessary updates
            unsub(); // Unsubscribe once the initial auth state is determined
        });
    }, []);

    // Provide authentication state and dispatch function to children components
    return <AuthContext.Provider value={{ ...state, dispatch, users, setUsers }}>{children}</AuthContext.Provider>;
};
// Custom hook to access the authentication context
export function useAuthContext() {
    // Get the authentication context from the nearest AuthContextProvider
    const context = useContext(AuthContext);

    // Check if the context was successfully obtained
    if (!context) {
        throw Error("useAuthContext must be used inside an AuthContextProvider");
    }

    // Return the authentication context object for use in components
    return context;
}
